export default {
    color: 'purple',
}
  